<template>
  <el-card class="box-card mt10" v-if="exceptionObj">
    <div class="tit3">异常通知</div>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-box ">
          <div class="grid-title"><img src="../../../assets/home4.png" alt="">推送异常</div>
          <div class="grid-content grid1">
            <p><span>{{exceptionObj.dinghuoCount}}</span><br />订货订单</p>
            <p><span>{{exceptionObj.miaoshaCount}}</span><br />秒杀订单</p>
            <p><span>{{exceptionObj.jifenCount}}</span><br />积分订单</p>
            <p><span>{{exceptionObj.fukuanCount}}</span><br />付款单</p>
            <p><span>{{exceptionObj.tuikuanCount}}</span><br />退款单</p>
            <p><span>{{exceptionObj.yonghuCount}}</span><br />用户</p>
            <p><span>{{exceptionObj.shoukuandanCount}}</span><br />收款单</p>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-box ">
          <div class="grid-title"><img src="../../../assets/home4.png" alt="">账户异常</div>
          <div class="grid-content grid2">
            <p><span>{{exceptionObj.yonghuzhanghuCount}}</span><br />用户账户</p>
            <p><span>{{exceptionObj.yewuzhanghuCount}}</span><br />业务账户</p>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-box ">
          <div class="grid-title"><img src="../../../assets/home4.png" alt="">客户等级变动</div>
          <div class="grid-content1 grid3">
            <p v-for="(item,index) in gradeList" :key="index">
              {{index + 1}}、{{item.customerPO.name}}{{item.customerPO.pho}}等级由{{item.fromClassify.name}}
              {{item.change.upOrDown === 1?'升':(item.change.upOrDown === 2?'降':'持平')}}至{{item.toClassify.name}}
            </p>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import homeStatisticsApi from '@/api/home'
export default {
  data() {
    return {
      exceptionObj: {},
      gradeList: []
    }
  },
  created() {
    this.getException()
    this.getclassifyChangeList()
  },
  methods: {
    getException() {
      homeStatisticsApi.getHomeException().then(res => {
        this.exceptionObj = res.data;
      })
    },
    getclassifyChangeList() {
      homeStatisticsApi.classifyChangeList({ pageNo: 1, pageSize: 100, upOrDown: 2 }).then(res => {
        this.gradeList = res.data.list
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-box {
  margin-top: 20px;
  padding: 16px;
  border: 1px solid #e73f3f;
  background: rgba(231, 63, 63, 0.1);
  border-radius: 6px;
  height: 224px;
  .grid-title {
    font-size: 12px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .grid-content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    // justify-content: space-between;
    p {
      font-size: 16px;
      line-height: 24px;
      position: relative;
      text-align: center;
    }
    &.grid1 {
      p {
        flex: 1;
        width: calc(
          (100% - 10px) / 4
        ); // 这里的10px = (分布个数3-1)*间隙5px, 可以根据实际的分布个数和间隙区调整
        min-width: calc(
          (100% - 10px) / 4
        ); // 加入min-width、max-width后每个child的宽度就生效了
        max-width: calc((100% - 10px) / 4);
        &:nth-child(4) {
          margin-right: 0; // 去除第3n个的margin-right
        }
      }
    }
    &.grid2 {
      p {
        flex: 1;
        width: calc(
          (100% - 10px) / 2
        ); // 这里的10px = (分布个数3-1)*间隙5px, 可以根据实际的分布个数和间隙区调整
        min-width: calc(
          (100% - 10px) / 2
        ); // 加入min-width、max-width后每个child的宽度就生效了
        max-width: calc((100% - 10px) / 2);
        &:nth-child(2) {
          margin-right: 0; // 去除第3n个的margin-right
        }
      }
    }
    &.grid3 {
      p {
        line-height: 20px;
        margin-bottom: 0;
        display: block;
      }
    }
  }
  .grid-content1 {
    height: 160px;
    overflow-y: auto;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
</style>